// extracted by mini-css-extract-plugin
export default {"menuListSwitchContainer":"MenuList_menuListSwitchContainer__mzMM7"};